import React, { useState } from 'react';
import Modal from './Modal';
const Footer = () => {
  const [modalContent, setModalContent] = useState({
    isOpen: false,
    title: '',
    content: ''
  });
  const openModal = (title, content) => {
    setModalContent({
      isOpen: true,
      title,
      content
    });
  };
  const closeModal = () => {
    setModalContent({
      ...modalContent,
      isOpen: false
    });
  };
  return <footer className="bg-gray-100 py-8" data-id="element-113">
      <div className="container mx-auto px-4" data-id="element-114">
        <div className="max-w-3xl mx-auto text-center" data-id="element-115">
          <p className="text-sm text-gray-600 mb-4" data-id="element-116">
            Este producto es un ebook digital de recetas y organización de
            cocina. No sustituye recomendaciones médicas ni nutricionales
            personalizadas.
          </p>
          <div className="flex justify-center space-x-6 mb-4" data-id="element-117">
            <button onClick={() => openModal('Términos y Condiciones', <div className="space-y-4" data-id="element-119">
                    <h3 className="font-bold" data-id="element-120">1. Acuerdo de compra</h3>
                    <p data-id="element-121">
                      Al adquirir "7 cenas latinas en 30 minutos", aceptas estos
                      términos y condiciones en su totalidad.
                    </p>
                    <h3 className="font-bold" data-id="element-122">2. Propiedad intelectual</h3>
                    <p data-id="element-123">
                      Todo el contenido de este ebook está protegido por
                      derechos de autor. No está permitida su reproducción,
                      distribución o comercialización sin autorización expresa.
                    </p>
                    <h3 className="font-bold" data-id="element-124">3. Uso personal</h3>
                    <p data-id="element-125">
                      La licencia de uso es personal e intransferible. Cada
                      comprador puede utilizar el material para su uso personal
                      únicamente.
                    </p>
                    <h3 className="font-bold" data-id="element-126">4. Política de devolución</h3>
                    <p data-id="element-127">
                      Ofrecemos garantía de devolución de 7 días. Si no estás
                      satisfecho, contacta con nuestro equipo para solicitar el
                      reembolso.
                    </p>
                    <h3 className="font-bold" data-id="element-128">5. Responsabilidad</h3>
                    <p data-id="element-129">
                      La información proporcionada en este ebook es de carácter
                      general y no sustituye el consejo profesional de
                      nutricionistas o especialistas en salud.
                    </p>
                  </div>)} className="text-gray-500 hover:text-custom-brown" data-id="element-118">
              Términos y Condiciones
            </button>
            <button onClick={() => openModal('Política de Privacidad', <div className="space-y-4" data-id="element-131">
                    <h3 className="font-bold" data-id="element-132">Recopilación de datos</h3>
                    <p data-id="element-133">
                      Recopilamos información básica de contacto cuando realizas
                      una compra, como nombre y correo electrónico.
                    </p>
                    <h3 className="font-bold" data-id="element-134">Uso de la información</h3>
                    <p data-id="element-135">
                      Utilizamos tu información para procesar tu compra,
                      brindarte acceso al producto y enviarte actualizaciones
                      relevantes.
                    </p>
                    <h3 className="font-bold" data-id="element-136">Protección de datos</h3>
                    <p data-id="element-137">
                      Tus datos están seguros con nosotros. No compartimos tu
                      información personal con terceros sin tu consentimiento
                      explícito.
                    </p>
                    <h3 className="font-bold" data-id="element-138">Cookies</h3>
                    <p data-id="element-139">
                      Nuestro sitio web utiliza cookies para mejorar tu
                      experiencia de navegación. Puedes desactivarlas en la
                      configuración de tu navegador.
                    </p>
                    <h3 className="font-bold" data-id="element-140">Derechos del usuario</h3>
                    <p data-id="element-141">
                      Tienes derecho a acceder, rectificar y eliminar tus datos
                      personales. Para ejercer estos derechos, contáctanos a
                      través de nuestro formulario de contacto.
                    </p>
                  </div>)} className="text-gray-500 hover:text-custom-brown" data-id="element-130">
              Política de Privacidad
            </button>
          </div>
          <p className="text-sm text-gray-500" data-id="element-142">
            Derechos reservados © 2025 Método Exprés Latino por CONECKTA+
          </p>
        </div>
      </div>
      <Modal isOpen={modalContent.isOpen} onClose={closeModal} title={modalContent.title} data-id="element-143">
        {modalContent.content}
      </Modal>
    </footer>;
};
export default Footer;